import StudentRegistrationForm from "../../components/forms/StudentRegistrationForm";
import Header from "../../components/Header";

export default function StudentRegistration() {
  return (
    <div className="flex min-h-screen flex-col">
      <Header />
      <main className="flex-1 bg-background py-12">
        <StudentRegistrationForm />
      </main>
      {/* <Footer /> */}
    </div>
  );
}
